import type { IServicingMsrLoan } from './types'

export const msrLoanInputs = (
  form: Partial<IServicingMsrLoan>,
  loanOptions: Record<string, string>,
): Record<string, any> => ({
  loanId: {
    inputType: 'select',
    title: 'Loan ID',
    options: loanOptions,
    value: form.loanId,
    hasDefaultOption: true,
    defaultOptionText: 'Select',
    required: true,
  },
  upbServiced: { inputType: 'text', type: 'number', title: 'UPB Serviced', value: form.upbServiced },
  capitalizedMsr: { inputType: 'text', type: 'number', title: 'Capitalized MSR', value: form.capitalizedMsr },
  accumAmort: { inputType: 'text', type: 'number', title: 'Accum. Amort.', value: form.accumAmort },
})
